<template>
  <div class="flex items-center">
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{params.value}}</router-link>
    <!-- <span>{{params.value}}</span> -->
    <!-- <vs-avatar :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" />
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{ params.value }}</router-link> -->
  </div>
</template>

<script>
    export default {
        name: 'AttendLink',
        data() {
          return {
            url: ''
          }
        },
        computed: {
          activeWorkspace() {
            return this.$store.state.space.ActiveSpaceInfo
          }
        },
        created(){
          // return "/apps/space/dashboard/attend/space/:spaceId/id/:userId8"
          // console.log(params)
          this.url = "/apps/project/insight/project/"+this.$route.params.projectId+"/user/"+this.params.data.user_id
        }
    }
</script>
